// スキップの確認：この場面のあらすじを見せてから「スキップしますか？」で確かめる（読まなくても話の流れがわかるように）。
// 物語の再生（screens/stories.ts）とプロローグ（screens/prologue.ts）で同じ札を使う。見た目は styles/screens/stories.css の .story-skip-dialog
import { esc } from '../ui/dom';

interface SkipDialogOptions {
  /** 題の上の小さな字（話の題など） */
  eyebrow: string;
  /** 場面の題 */
  title: string;
  /** あらすじ（STORY_SUMMARIES） */
  summary: string;
  /** ✓ を押したとき（札を閉じてから呼ぶ） */
  skip: () => void;
  /** 札が閉じたとき（✓・×・枠の外・Esc・外から閉じたときのすべて） */
  closed?: () => void;
}

/** スキップの確認の札を開く。戻り値は外から閉じる関数（画面を離れるときなど） */
export function openSkipDialog({ eyebrow, title, summary, skip, closed }: SkipDialogOptions): () => void {
  const dialog = document.createElement('dialog');
  dialog.className = 'story-dialog story-skip-dialog';
  dialog.setAttribute('aria-label', 'スキップの確認');
  dialog.innerHTML = `<small>${esc(eyebrow)}</small><h2>${esc(title)}</h2><p class="story-skip-summary">${esc(summary)}</p>
    <div class="story-skip-ask"><button class="story-skip-no" data-no aria-label="読み続ける">×</button><span>スキップしますか？</span><button class="story-skip-yes" data-yes aria-label="スキップする">✓</button></div>`;
  document.body.appendChild(dialog);
  let open = true;
  const close = () => {
    if (!open) return;
    open = false;
    dialog.close(); dialog.remove(); closed?.();
  };
  dialog.addEventListener('cancel', e => { e.preventDefault(); close(); });
  dialog.addEventListener('click', e => {
    const t = e.target as HTMLElement;
    if (t.closest('[data-yes]')) { close(); skip(); }
    else if (t.closest('[data-no]') || t === dialog) close();
  });
  dialog.showModal();
  return close;
}
